<template>       
   <div id="app-body-container" >      
    <div>
          <form role="form">
              <div v-if="passwordNotSupported">
                  <div  class="alert alert-dismissible alert-warning">
                  <button type="button" class="close" data-dismiss="alert">&times;</button>
                  <p><i class="fas fa-exclamation-triangle"></i>&nbsp;&nbsp;<span>{{ $t("generic.password-not-supported") }}</span></p>
              </div>
              </div>               
              <FileChooser v-if="!extractService"                           
                           @file-chosen="setFile"
                           :accepted-extensions="acceptedExtensions"
              />

              <Password v-if="passwordRequired && !passwordNotSupported" :error="passwordError" @set-password="setPassword" />
              
              <div v-if="loading">                  
                  <h3>{{ $t("ZIP.processing") }}<img class="loading-svg" src="https://www.ezyzip.com/assets/images/loading.svg" alt="uploading"  ></h3>                                                                    
              </div>

              <div v-if="savingAll">
                  <ProgressIndicator v-if="!savingAllDone" :progress="savingProgress" :label="$t('generic.saving')" />                  
                  
                  <div v-if="savingAllDone">
                    <div v-if="!(savingAllUnsavedFiles.length > 0)">
                      <h3  style="margin-top:0">{{ $t("generic.all-files-saved") }}</h3>                    
                      <p v-if="!savingAllDropboxDone">                        
                          {{ $t("generic.all-files-saved-description") }}                        
                      </p>
                      <p v-if="savingAllDropboxDone">                        
                          {{ $t("generic.all-files-saved-dropbox-description") }}                        
                      </p>
                    </div>
                    <div v-if="savingAllUnsavedFiles.length > 0">                              
                        <h3 style="margin-top:0">{{ $t('generic.could-not-save-all-files') }}</h3>
                        <p>{{ $t('generic.could-not-save-all-files-description') }}</p>                          
                        <FileList :show-directories="false" :show-directories-button="false" :file-list="savingAllUnsavedFiles" :extract-service="extractService"   />  
                    </div>
                    <a  :href="$t('page.pageRoute')" class="btn btn-primary btn-lg" style="margin-top:20px">{{ $t("generic.extract-another-file") }}</a>
                  </div>
              </div>  

              <div v-if="!passwordRequired">
                <div v-if="extractService && !savingAll" >
                    <!-- <div class="form-group" v-if="!savingAll && extractedFiles.length > 0 && !passwordRequired"> -->
                      <div class="form-group" v-if="extractService && !loading && fileList.size > 0">
                        <h3 class="file-list-heading" style="line-height:80%;margin-bottom:0" >
                          <div class="btn-group float-end">
                              <!-- :disabled wasnt working, so using v-if -->
                              <a v-if="canSaveAll" :title="$t('generic.select-folder')" v-on:click="saveAll"  style="padding-right:2px" href="#" class="btn btn-success">{{ $t("generic.save-all") }}</a>
                              <a v-if="!canSaveAll" disabled :title="$t('generic.no-browser-support')"   style="padding-right:2px" href="#" class="btn btn-success">{{ $t("generic.save-all") }}</a>                            
                              
                              <a href="#" class="btn btn-success save-all-btn dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-toggle="dropdown"><span class="caret"></span></a>
                              <div  class="dropdown-menu save-all-dropdown bg-success" aria-labelledby="saveAllDrop">            
                                  <a class="dropdown-item" v-on:click="saveAllToDropbox()" rel="nofollow" href="#"><i class="fab fa-dropbox"></i>&nbsp;Dropbox</a>                                  
                              </div>                              
                          </div>
                          
                          <a :href="$t('page.pageRoute')" class="btn btn-default float-end " style="margin-right:5px"> {{ $t("generic.reset") }}</a>
                          
                          {{ fileName}}<br>
                          <span style="font-size:14px">{{ fileCount }} {{ $t('generic.files') }}, {{totalSize }}</span>    
                        </h3>                                          
                      <FileList :show-directories="extensionFilter? false: true" 
                                :show-directories-button="true"
                                :file-list="fileList" 
                                :extract-service="extractService" 
                                @password-error="setPasswordError"  />
                    </div>                    
                    <div v-if="!loading">
                          <div v-if="fileList.size < unFilteredCount && fileList.size > 0">
                              <span v-html="$t('CONVERT.other-files-found')"></span>
                          </div>
                          <div v-if="fileList.size == 0">                                  
                              <span v-html="$t('CONVERT.no-files-found')"></span>
                          </div>
                    </div>
                </div>
              </div>  
          </form>
      </div>      
    </div>
</template>

<script>
import FileChooser from './ui/FileChooser.vue'
import FileList from './ui/FileList.vue'
import Password from './ui/Password.vue'
import ProgressIndicator from './ui/ProgressIndicator.vue'
import ExtractService from '../services/ExtractService'
import filesize from '../services/filesize'
import { checkPasswordError, gaEvent, gaException, gaScreen } from '../services/Utils'


export default {
  name: 'Extract',
  props: {
    dropFiles: Object,
    acceptedExtensions: String,
    extensionFilter: String
  },
  computed: {
      dropFilesUpdate() {        
        // TODO: Maybe fix this hacky solution one day...?
            
        return this.dropFiles;
      },
      canSaveAll() {
            return window.showDirectoryPicker || window.chooseFileSystemEntries ? true: false;
        }
    },
  components: {
    FileChooser,
    FileList,
    ProgressIndicator,
    Password
  },
  data() {
       return {
           extractService: null,
           fileExtension: null,
           fileList: new Set(),
           loading: false,
           password: '',
           passwordRequired: false,
           passwordError: false,
           passwordNotSupported: false,
           savingAll: false,
           savingAllUnsavedFiles: [],
           savingAllDone: false,
           savingAllDropboxDone: false,           
           savingProgress: {currentFile: '', progress: 0},
           unFilteredCount: 0,
           fileCount: 0,
           totalSize: 0
       }
    },
    watch: {
      dropFiles(newDropFiles) {        
        this.setFile({file: newDropFiles.files[0]});        
      }
    },
    methods: {       
        saveAllToDropbox: async function(){          
          try {
            this.savingAll = true;
            await this.extractService.saveAllToDropbox((progress) => {                        
                this.savingProgress = progress;
            });
            this.savingAllDone = true;
            this.savingAllDropboxDone = true;            
            gaScreen('extract2-save-all-dropbox');
          } catch(e) {            
            if (checkPasswordError(e)) {
                this.savingAll = false;
                this.setPasswordError();
                gaEvent('extract2-incorrect-password', window.location.pathname); 
              } else {
                alert('ERROR: Could not save files to dropbox');                   
                console.log(e);
                this.savingAll = false;                                
                gaException('extract2-save-all-error-dropbox|' + this.fileName + '|' + JSON.stringify(e.message? e.message: e));
            }
          }
        },        
        async setPassword(password) {
          //this.passwordRequired = false;
          //this.convertService.setPassword(password);
          this.loading = true;
          this.passwordRequired = false;
          try {
          await this.extractService.setPassword(password);
          
          if (this.fileList.size < 1) {
            console.log('fetching file list again');
            
            this.fileList = await this.extractService.getFileList(true);
                let totalSize = 0;
                this.fileCount = Array.from(this.fileList).filter(f => {
                                    totalSize = totalSize +  f.size;
                                    return !f.isDirectory}).length;
                this.totalSize = filesize(totalSize);
                  //console.log('fileList', fileList);
                this.unFilteredCount = this.extractService.getUnfilteredCount();
            } 
          } catch(e) {
              
              if (checkPasswordError(e)) {        
                  this.savingAll = false;                                                      
                  this.setPasswordError();
                  gaEvent('extract2-incorrect-password-2', window.location.pathname); 
                }  else {                         
                  console.log(e);
                  alert('Could not open file')
                  this.savingAll = false;      
                  this.loading = false;
                this.extractService = null;                            
                  gaException('extract2-set-password-error|' + this.fileName + '|' + JSON.stringify(e.message? e.message: e));
                }
          }
                
          this.loading = false;
        },                 
        saveAll: async function() {
            try {
                
                this.savingAll = true;
                if (this.canSaveAll) {
                    let dirHandle;                
                    if(window.showDirectoryPicker) {
                        dirHandle = await window.showDirectoryPicker();
                    } else {
                        dirHandle = await window.chooseFileSystemEntries({type: 'open-directory'});  
                    }                    
                    console.log('start', new Date());
                    const saveAllResult = await this.extractService.saveAll(dirHandle, (progress) => {
                        this.savingProgress = progress;
                    });
                    this.savingAllUnsavedFiles = saveAllResult.unallowedFiles;                    
                    this.savingAllDone = true;
                    console.log('end', new Date());
                    gaScreen('extract2-save-all');
                }
                
            } catch (e) {
                // not always an error, could just be a cancel...         
                if (checkPasswordError(e)) {        
                  this.savingAll = false;                                                      
                  this.setPasswordError();
                  gaEvent('extract2-incorrect-password', window.location.pathname); 
                } else if(e.message && e.message.indexOf('aborted') > -1) {                    
                      console.log(e);                                            
                      this.savingAll = false; 
                      gaEvent('extract2-aborted-info', window.location.pathname);
                  } else {       
                  alert('Error saving all');
                  console.log(e);
                  this.savingAll = false;                                  
                  gaException('extract2-save-all-error|' + this.fileName + '|' + JSON.stringify(e.message? e.message: e));
                }                
            }                
        },
        setPasswordError: function() {          
            this.passwordRequired = true;
            this.passwordError = true; 
        },
        setFile: async function(fileChooser) {       
            this.passwordNotSupported = false;     
            this.loading = true;
            this.fileName = fileChooser.file.name;
            this.fileExtension = fileChooser.file.name.split('.').pop().toLowerCase();            
                        
            if(this.acceptedExtensions.indexOf(this.fileExtension) > -1) {            
              try {
                

                this.extractService = new ExtractService(fileChooser.file, this.extensionFilter );                
                let fileList = await this.extractService.getFileList();
                this.fileList = fileList;
                let totalSize = 0;
                this.fileCount = Array.from(this.fileList).filter(f => {
                                    totalSize = totalSize +  f.size;
                                    return !f.isDirectory}).length;
                this.totalSize = filesize(totalSize);
                  //console.log('fileList', fileList);
                this.unFilteredCount = this.extractService.getUnfilteredCount();
                this.passwordRequired = this.extractService.isEncrypted();
                
                this.loading = false;

                //gaEvent('extract2-set-file-success', window.location.pathname);                 
              } catch (e) {
                alert('Error loading file!');
                console.log('extract2-set-file-error|' + e);                
                gaException('extract2-set-file-error|' + this.fileName + '|' + JSON.stringify(e.message? e.message: e));

                this.loading = false;
                this.extractService = null;
              }
            } else {
              this.loading = false;
              console.log('invalid file extension');
            }            
          }
    }
}

</script>
<style scoped>
    
  
  </style>